/** Índices CPO-ceo (MSP historia clínica Ecuador) */

export const CPO_PERMANENTE_COLS = [
  { key: 'indiceCPO_C', label: 'C', title: 'Caries', kind: 'caries' },
  { key: 'indiceCPO_P', label: 'P', title: 'Perdidos', kind: 'perdidos' },
  { key: 'indiceCPO_O', label: 'O', title: 'Obturados', kind: 'obturados' },
];

export const CEO_DECIDUO_COLS = [
  { key: 'indiceCeo_c', label: 'c', title: 'Caries', kind: 'caries' },
  { key: 'indiceCeo_e', label: 'e', title: 'Extraídos', kind: 'perdidos' },
  { key: 'indiceCeo_o', label: 'o', title: 'Obturados', kind: 'obturados' },
];

export const CPO_CEO_FILAS = [
  {
    rowLabel: 'D',
    rowTheme: 'permanente',
    rowHint: 'Dientes permanentes (CPO)',
    cols: CPO_PERMANENTE_COLS,
    totalKey: 'indiceCPO_Total',
  },
  {
    rowLabel: 'd',
    rowTheme: 'deciduo',
    rowHint: 'Dientes deciduos (ceo)',
    cols: CEO_DECIDUO_COLS,
    totalKey: 'indiceCeo_Total',
  },
];

function parseIndiceVal(val) {
  if (val === '' || val === null || val === undefined) return null;
  const n = Number(String(val).trim());
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.floor(n);
}

/** Normaliza texto de celda C/P/O (solo dígitos; vacío permitido). */
export function normalizeIndiceCpoCeoInput(raw) {
  if (raw === '' || raw === null || raw === undefined) return '';
  const s = String(raw).trim();
  if (s === '') return '';
  const n = parseIndiceVal(s);
  return n === null ? '' : String(n);
}

/** Suma C+P+O (o c+e+o); vacío si no hay ningún valor ingresado. */
export function calcularIndiceTotal(values, colKeys) {
  let sum = 0;
  let any = false;
  colKeys.forEach((key) => {
    const n = parseIndiceVal(values?.[key]);
    if (n !== null) {
      sum += n;
      any = true;
    }
  });
  return any ? String(sum) : '';
}

export function getIndiceTotalForFila(form, fila) {
  const keys = fila.cols.map((c) => c.key);
  return calcularIndiceTotal(form, keys);
}

/** Actualiza totales al cambiar una celda del índice. */
export function patchIndiceConTotales(prev, fieldKey, rawValue) {
  const next = { ...prev, [fieldKey]: normalizeIndiceCpoCeoInput(rawValue) };
  CPO_CEO_FILAS.forEach((fila) => {
    const keys = fila.cols.map((c) => c.key);
    if (keys.includes(fieldKey)) {
      next[fila.totalKey] = calcularIndiceTotal(next, keys);
    }
  });
  return next;
}

export function recalcularTodosLosTotalesCpoCeo(form) {
  let next = { ...form };
  CPO_CEO_FILAS.forEach((fila) => {
    const keys = fila.cols.map((c) => c.key);
    next[fila.totalKey] = calcularIndiceTotal(next, keys);
  });
  return next;
}
